export default {"src":"/_next/static/media/crypto-icons.d18719fe.svg","height":40,"width":280,"blurWidth":0,"blurHeight":0};